//src/pages/admin/tabs/managers/ManagersListPage.jsx

import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { AdminAPI } from '../../../../api/admin';
import { normalizeMediaUrl } from '../../../../api/base';
import { Card, Row2, Field, Actions, Btn, Badge, TableWrap, Table, Paginator, PageBtn } from '../../ui';

const Wrap = styled.div`display:grid; gap:20px;`;

const DEFAULT_Q = { page: 1, page_size: 20, is_active: '', region_id: '', q: '', locale: 'ru' };

function fullName(m){
  const f = m.first_name ?? m.first_name_ru ?? m.first_name_en ?? '';
  const l = m.last_name  ?? m.last_name_ru  ?? m.last_name_en  ?? '';
  const ready = `${f} ${l}`.trim();
  return ready || m.full_name || `#${m.id}`;
}
function pos(m){ return m.position ?? m.position_ru ?? m.position_en ?? ''; }

export default function ManagersListPage(){
  const [query, setQuery] = React.useState(DEFAULT_Q);
  const [items, setItems] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState('');
  const nav = useNavigate();

  const totalPages = Math.max(1, Math.ceil((total || items.length) / (query.page_size || 20)));

  const load = React.useCallback(async ()=>{
    setLoading(true);
    setErr('');
    try{
      const d = await AdminAPI.listManagers({
        page: query.page,
        page_size: query.page_size,
        is_active: query.is_active || undefined,
        region_id: query.region_id || undefined,
        q: query.q || undefined,
        locale: query.locale || 'ru',
      });
      const list = d?.items || [];
      const tot  = d?.pagination?.total ?? list.length;
      setItems(list); setTotal(tot);
    } catch (e) {
      console.error(e);
      setItems([]); setTotal(0);
        setErr(
        e?.payload?.details
            ? (typeof e.payload.details === 'string' ? e.payload.details : JSON.stringify(e.payload.details))
            : (e?.payload?.error?.message || e?.payload?.message || e?.message || 'Не удалось загрузить список менеджеров')
        );    } finally {
      setLoading(false);
    }
  }, [query]);

  React.useEffect(()=>{ load(); }, [load]);

  const goPage = (n) => setQuery(q => ({ ...q, page: Math.max(1, Math.min(n, totalPages)) }));

  const del = async (m, hard=false)=>{
    if (!window.confirm(hard ? 'Удалить менеджера ЖЁСТКО? Действие необратимо.' : 'Деактивировать менеджера?')) return;
    try{
      await AdminAPI.deleteManager(m.id, { hard });
      await load();
    }catch(e){ alert(e?.message || 'Не удалось удалить'); }
  };

  return (
    <Wrap>
      <Card>
        <h3>Менеджеры</h3>
        <Actions style={{marginTop:8, gap:10, flexWrap:'wrap', alignItems:'end'}}>
          <Field>Поиск
            <input value={query.q} onChange={e=>setQuery(q=>({...q, q:e.target.value, page:1}))} placeholder="имя / телефон / email" />
          </Field>
          <Row2>
            <Field>Активен
              <select value={query.is_active} onChange={e=>setQuery(q=>({...q, is_active:e.target.value, page:1}))}>
                <option value="">все</option>
                <option value="true">да</option>
                <option value="false">нет</option>
              </select>
            </Field>
            <Field>Регион (ID)
              <input type="number" value={query.region_id} onChange={e=>setQuery(q=>({...q, region_id:e.target.value, page:1}))} placeholder="необязательно" />
            </Field>
            <Field>На странице
              <select value={query.page_size} onChange={e=>setQuery(q=>({...q, page_size:Number(e.target.value), page:1}))}>
                <option value={10}>10</option><option value={20}>20</option><option value={50}>50</option><option value={100}>100</option>
              </select>
            </Field>
          </Row2>
          <Btn onClick={()=>setQuery(DEFAULT_Q)}>Сброс</Btn>
          <Btn onClick={load}>Обновить</Btn>
          <Badge>Найдено: <b>{total || items.length}</b></Badge>
          <div style={{flex:1}} />
          <Btn $kind="primary" onClick={()=>nav('/admin/managers/new')}>+ Создать менеджера</Btn>
        </Actions>
      </Card>

      <Card>
        <h3>Список {loading ? '(загрузка...)' : ''}</h3>
        {err && <div style={{color:'#e66', marginBottom:8}}>{err}</div>}
        <TableWrap>
          <Table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Фото</th>
                <th>Имя</th>
                <th>Должность</th>
                <th>Телефон</th>
                <th>Email</th>
                <th>Активен</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map(m=>(
                <tr key={m.id}>
                  <td>{m.id}</td>
                  <td>{(m.avatar_thumb || m.avatar_url || m.avatar) ? <img src={normalizeMediaUrl(m.avatar_thumb || m.avatar_url || m.avatar)} alt="" style={{width:44,height:44,borderRadius:22,objectFit:'cover'}}/> : null}</td>
                  <td style={{maxWidth:260}}>
                    <div style={{fontWeight:700}}>{fullName(m)}</div>
                  </td>
                  <td>{pos(m) || '—'}</td>
                  <td>{m.phone || m.phone_secondary || m.telegram || '—'}</td>
                  <td>{m.email || '—'}</td>
                  <td>{m.is_active ? 'Да' : 'Нет'}</td>
                  <td style={{display:'flex', gap:8}}>
                    <Link className="btn" to={`/admin/managers/${m.id}`}>Редактировать</Link>
                    {m.is_active
                      ? <Btn onClick={()=>del(m,false)}>Деактивировать</Btn>
                      : <>
                          <Btn onClick={()=>del(m,true)}>Удалить жёстко</Btn>
                          <span style={{opacity:.6, fontSize:12}}>деактивирован</span>
                        </>
                    }
                  </td>
                </tr>
              ))}
              {!items.length && !loading && (
                <tr><td colSpan={8} style={{opacity:.7}}>Нет данных</td></tr>
              )}
            </tbody>
          </Table>
        </TableWrap>

        <Paginator>
          <PageBtn onClick={()=>goPage(1)} disabled={query.page<=1}>« Первая</PageBtn>
          <PageBtn onClick={()=>goPage(query.page-1)} disabled={query.page<=1}>‹ Назад</PageBtn>
          <PageBtn data-active="true">{query.page} / {totalPages}</PageBtn>
          <PageBtn onClick={()=>goPage(query.page+1)} disabled={query.page>=totalPages}>Вперёд ›</PageBtn>
          <PageBtn onClick={()=>goPage(totalPages)} disabled={query.page>=totalPages}>Последняя »</PageBtn>
        </Paginator>
      </Card>
    </Wrap>
  );
}
